// @flow
import type {
  RegisterUserType,
  LoginUserType,
  AuthenticatedUserType,
  ForgotPasswordType,
  Error,
  UpdateUserType,
  Locale,
  SignoutActionType,
} from "../types";
import { ActionType } from "../types";
import { FETCH_PROFILE } from "../constants/actionTypesTpos";
import {
  GET_GEO_LOCATION_PERMISSION,
  REGISTER_PROCESS,
  AUTHENTICATE_USER_START,
  REGISTER_USER_DONE,
  REGISTER_USER_ERROR,
  STARTUP_PROCESS,
  LOGIN_PROCESS,
  LOGIN_USER_DONE,
  LOGIN_USER_ERROR,
  FORGOT_PASSWORD_PROCESS,
  FORGOT_PASSWORD_DONE,
  FORGOT_PASSWORD_ERROR,
  UPDATE_USER_PROCESS,
  UPDATE_USER_START,
  UPDATE_USER_ERROR,
  UPDATE_USER_DONE,
  SIGNOUT,
  UPDATE_FCM_TOKEN,
  UPDATE_DEVICE_TOKEN,
  INVALID_TOKEN,
  INVALIDATE_SESSION,
  LOCALE_CHANGE,
  SMS_VERIFICATION,
  SMS_VERIFICATION_DONE,
  SMS_VERIFICATION_ERROR,
  RESET_SMS_VERIFICATION,
  RESEND_OTP,
  RESEND_OTP_ERROR,
  RESEND_OTP_DONE,
  CLEAR_OTP_ERRORS,
  CLEAR_REGISTER_USER_TOKEN,
  DO_VERIFICATIONS,
  HANDLE_NOTIFICATIONS,
} from "../constants/actionTypes";
import { StartupProcesAction } from "../types/general";

export function getGeoLocationPermissions(): ActionType<undefined> {
  return { type: GET_GEO_LOCATION_PERMISSION };
}

export function startupProcess(): StartupProcesAction {
  return { type: STARTUP_PROCESS };
}

export function loginProcess(
  payload: LoginUserType,
): ActionType<LoginUserType> {
  return { type: LOGIN_PROCESS, payload };
}

export function registerProcess(
  payload: RegisterUserType,
  onSuccess?: (isVerified: boolean) => void,
): ActionType<RegisterUserType> & {
  onSuccess?: (isVerified: boolean) => void;
} {
  return { type: REGISTER_PROCESS, payload, onSuccess };
}

export function forgotPasswordProcess(
  payload: ForgotPasswordType,
): ActionType<ForgotPasswordType> {
  return { type: FORGOT_PASSWORD_PROCESS, payload };
}

export function updateUserProcess(
  payload: UpdateUserType,
  onComplete?: () => void,
): ActionType<UpdateUserType> & {
  onComplete?: (isVerified: boolean) => void;
} {
  return { type: UPDATE_USER_PROCESS, payload, onComplete };
}

export function doUpdateUserStart(): ActionType<undefined> {
  return { type: UPDATE_USER_START };
}

export function doUpdateUserError(payload: string): ActionType<string> {
  return { type: UPDATE_USER_ERROR, payload };
}

export function doUpdateUserDone(
  payload: UpdateUserType,
): ActionType<UpdateUserType> {
  return { type: UPDATE_USER_DONE, payload };
}

export function doAuthenticateUserStart(): ActionType<undefined> {
  return { type: AUTHENTICATE_USER_START };
}

export function doRegisterUserDone(
  payload: RegisterUserType,
): ActionType<LoginUserType> {
  return { type: REGISTER_USER_DONE, payload };
}

export function doRegisterUserError(payload: Error): ActionType<Error> {
  return { type: REGISTER_USER_ERROR, payload };
}

export function doLoginUserDone(
  payload: AuthenticatedUserType,
): ActionType<AuthenticatedUserType> {
  return { type: LOGIN_USER_DONE, payload };
}

export function doLoginUserError(payload: Error): ActionType<Error> {
  return { type: LOGIN_USER_ERROR, payload };
}

export function doForgotPasswordDone(payload: boolean): ActionType<boolean> {
  return { type: FORGOT_PASSWORD_DONE, payload };
}

export function doForgotPasswordError(payload: Error): ActionType<Error> {
  return { type: FORGOT_PASSWORD_ERROR, payload };
}

export function signOut(): SignoutActionType {
  return { type: SIGNOUT };
}

export function invalidToken(): ActionType<undefined> {
  return { type: INVALID_TOKEN };
}

export function invalidateSession(): ActionType<undefined> {
  return { type: INVALIDATE_SESSION };
}

export function updateFcmToken(): ActionType<undefined> {
  return { type: UPDATE_FCM_TOKEN };
}

export function localeChange(locale: Locale): ActionType<Locale> {
  return { type: LOCALE_CHANGE, payload: locale };
}

export function updateDeviceToken(): ActionType<undefined> {
  return { type: UPDATE_DEVICE_TOKEN };
}

export function smsVerification(otp: string): ActionType<{ otp: string }> {
  return { type: SMS_VERIFICATION, payload: { otp } };
}

export function smsVerificationDone(): ActionType<undefined> {
  return { type: SMS_VERIFICATION_DONE };
}

export function smsVerificationError(error: string): ActionType<string> {
  return { type: SMS_VERIFICATION_ERROR, payload: error };
}

export function resetSmsVerification(): ActionType<undefined> {
  return { type: RESET_SMS_VERIFICATION };
}

export function resendOtp(telephone: string): ActionType<string> {
  return { type: RESEND_OTP, payload: telephone };
}

export function resendOtpError(error: string): ActionType<string> {
  return { type: RESEND_OTP_ERROR, payload: error };
}

export function resendOtpDone(remainingAttempts: number): ActionType<number> {
  return { type: RESEND_OTP_DONE, payload: remainingAttempts };
}

export function clearOtpErrors(): ActionType<undefined> {
  return { type: CLEAR_OTP_ERRORS };
}

export function clearRegisterUserToken(): ActionType<undefined> {
  return { type: CLEAR_REGISTER_USER_TOKEN };
}

export function doVerifications(telephone: string): ActionType<string> {
  return { type: DO_VERIFICATIONS, payload: telephone };
}

export function handleNotifications(payload: unknown): ActionType<unknown> {
  return { type: HANDLE_NOTIFICATIONS, payload };
}

export function fetchProfile(): ActionType<undefined> {
  return { type: FETCH_PROFILE };
}
